import {
  LIST_POLL_ANSWER,
  LIST_POLL_ANSWER_SUCCESS,
  LIST_POLL_ANSWER_CLEAN,
  LIST_POLL_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  pollAnswer: undefined,
}

const PollAnswerList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_POLL_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_POLL_ANSWER_SUCCESS:
      state = {
        ...state,
        pollAnswer: action.payload.pollAnswer,
        loading: false,
        done: true,
      }
      break
    case LIST_POLL_ANSWER_CLEAN:
      state = initialState
      break
    case LIST_POLL_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default PollAnswerList
